import React, { useEffect } from 'react';
import { useParams } from 'react-router';

import { useAction } from 'Modules/core/redux';
import { useDesktop, Stack, Typography, Box, useMobile } from 'Modules/ui3';
import { useStorageItem } from 'Modules/business/data';

import { NewsDetail } from '../../components/NewsDetail';
import { PageContainer } from '../../components/PageContainer';
import { NewsItem, newsActions } from '../../state/news';
import { NEWS_DOMAIN_PATH } from '../../api';
import { NewsPreview } from '../../components/NewsPreview';
import { TelegramButton } from '../../components/Social';
import { News } from '../../components/News';
import { NewsSlideContainer } from '../../components/NewsSlide';


export const NewsDetailPage = () => {
    const { id } = useParams<{ id: string }>();
    const isDesktop = useDesktop();
    const isMobile = useMobile();
    const getNewsItem = useAction(
        () => newsActions.getItem({ id, screenType: isDesktop ? 'desktop' : 'mobile' }),
        [id, isDesktop],
    );

    useEffect(() => {
        getNewsItem();
    }, [getNewsItem]);
    const { Neighbours, RenderContent, Tags } =
        useStorageItem<NewsItem>(NEWS_DOMAIN_PATH, id) || {};
    return (
        <PageContainer withMainButton>
            <Stack direction={isDesktop ? 'row' : 'column'} alignItems={isDesktop ? 'flex-start' : 'normal'} spacing={isDesktop ? 2 : 6}>
                <Box flex={2}>
                    <NewsDetail RenderContent={RenderContent} Tags={Tags} />
                </Box>
                <Stack spacing={8} alignItems='flex-start' flex={1}>
                    {isDesktop && Neighbours?.Next && (
                        <NewsSlideContainer>
                            <NewsPreview {...Neighbours?.Next} />
                        </NewsSlideContainer>
                    )}
                    <Stack spacing={3} px={isDesktop ? 8 : 0} alignItems='flex-start'>
                        <Typography fontSize={isDesktop ? '20px' : '16px'} fontWeight='500' lineHeight={isDesktop ? '1.6' : '1.5'}>
                            Всё о рынке ЦФА, подписывайтесь!
                        </Typography>
                        <TelegramButton />
                    </Stack>
                </Stack>
            </Stack>
            <News rowCount={isMobile ? 2 : 1} />
        </PageContainer>
    );
};
